/**
 * Document Status code;
 *
 * Corresponds to DocumentStatus in Billiant Core
 */
export enum DocumentStatus {
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",
}
